import type Rollbar from 'rollbar';

import { DrycutApolloProvider } from '@drycut/apollo';
import { env } from '@drycut/navigation';
import { Provider } from '@rollbar/react';
import { StrictMode } from 'react';
import * as ReactDOM from 'react-dom/client';
import { RouterProvider } from 'react-router';

import './styles.css';
import router from './router';

const root = ReactDOM.createRoot(document.getElementById('root') as HTMLElement);

const ROLLBAR_ACCESS_TOKEN = import.meta.env.VITE_ROLLBAR_ACCESS_TOKEN;

const rollbarConfig: Rollbar.Configuration = {
  accessToken: ROLLBAR_ACCESS_TOKEN,
  environment: env,
  enabled: env === 'production',
  captureUncaught: true,
  captureUnhandledRejections: true,
  payload: {
    client: {
      javascript: {
        code_version: '1.0.0',
        source_map_enabled: true,
      },
    },
  },
};

root.render(
  <Provider config={rollbarConfig}>
    <DrycutApolloProvider>
      <StrictMode>
        <RouterProvider router={router} />
      </StrictMode>
    </DrycutApolloProvider>
  </Provider>,
);
